import { render, staticRenderFns } from "./AutoDMCard.vue?vue&type=template&id=7af93f5c&"
import script from "./AutoDMCard.vue?vue&type=script&lang=js&"
export * from "./AutoDMCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports